import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { PreloaderComponent } from 'src/app/components/preloader/preloader.component';
import { EnvironmentService } from './core/services/environment.service';

import {Router, NavigationEnd} from '@angular/router';
import { DOCUMENT } from '@angular/common';
declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class AppComponent {
  title = 'virtual-office';
  loaderComponent = PreloaderComponent;
  filteredUrlPatterns = [];
  constructor(private environmentService: EnvironmentService, public router: Router, @Inject(DOCUMENT) private _document) {

  this.router.events.subscribe (event => {
      if (event instanceof NavigationEnd) {
          gtag ('config', 'G-738LP822LY', 
                {
                  'pageview': event.urlAfterRedirects
                }
               );

          this.filtrarUrlForBackgroundColorInBody(event.url)
       }
    }
  )

  }
  ngOnInit() {

    this.filteredUrlPatterns.push(`${this.environmentService.backOfficeServiceUrl}Notification/UpdateReadingNotification`)
  }

  filtrarUrlForBackgroundColorInBody(url){
    let array = url.split('/');
    if(array[2] == 'tienda'){
      this._document.body.classList.add('bg-white-gris');
    }
  }
}
